import { useTranslation } from "react-i18next";
import {
  StageShell, ColumnHeader, Metric, HelpDot, pctStr,
} from "./primitives";

export default function Stage4Tenant({ calc, fmtM }) {
  const { t } = useTranslation();

  return (
    <StageShell
      step={t("jc4_step")}
      role={t("jc4_role")}
      title={t("jc4_title")}
      desc={t("jc4_desc")}
      accentBg="bg-[#FF3B30]"
      accentText="text-white"
    >
      <div className="grid grid-cols-12 gap-6 mt-6">
        <div className="col-span-12 md:col-span-5">
          <ColumnHeader label={t("jc_stage_in")} accent="text-zinc-700" />
          <div className="space-y-5 border border-black/10 bg-white p-5">
            <Metric k={t("jc4_in_pay")} v={fmtM(calc.monthlyNet, 0)} big tip={t("tip_t_pay")} />
            <Metric k={t("jc4_in_advance")} v={fmtM(0, 0)} accent="text-zinc-400" big tip={t("tip_advance_req")} />
            <div className="text-xs text-zinc-500 leading-relaxed">
              {t("calc_landlord_cannot_demand")}
            </div>
          </div>
        </div>

        <div className="col-span-12 md:col-span-7">
          <ColumnHeader label={t("jc_stage_out")} accent="text-[#002FA7]" />
          <div className="border border-black/10 bg-white p-6">
            <div className="font-mono-label text-[10px] text-zinc-500 mb-4 flex items-center">
              <span>{t("jc4_out_split")}</span>
              <HelpDot tip={t("tip_split")} />
            </div>
            <div className="h-8 flex border border-black/10 overflow-hidden">
              <div className="bg-[#002FA7]" style={{ width: `${calc.splitAmcPct * 100}%` }} />
              <div className="bg-[#FFCC00]" style={{ width: `${calc.splitInvPct * 100}%` }} />
            </div>
            <div className="grid grid-cols-2 gap-3 mt-5">
              <div>
                <div className="flex items-center gap-2">
                  <span className="w-2.5 h-2.5 bg-[#002FA7] inline-block" />
                  <div className="font-mono-label text-[9px] text-zinc-600 truncate">{t("jc4_out_split_amc")}</div>
                </div>
                <div className="font-display text-lg font-black mt-1 tabular-nums">{fmtM(calc.amcMonthlyFee, 0)}</div>
                <div className="text-[10px] text-zinc-500 mt-0.5">{pctStr(calc.splitAmcPct, 1)}</div>
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <span className="w-2.5 h-2.5 bg-[#FFCC00] inline-block" />
                  <div className="font-mono-label text-[9px] text-zinc-600 truncate">{t("jc4_out_split_inv")}</div>
                </div>
                <div className="font-display text-lg font-black mt-1 tabular-nums">{fmtM(calc.netToInvestors, 0)}</div>
                <div className="text-[10px] text-zinc-500 mt-0.5">{pctStr(calc.splitInvPct, 1)}</div>
              </div>
            </div>
            <div className="mt-6 pt-5 border-t border-black/10">
              <Metric k={t("jc4_out_term_total")} v={fmtM(calc.totalFutureNet, 0)} tip={t("tip_term_total")} />
            </div>
          </div>
        </div>
      </div>
    </StageShell>
  );
}
